// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Char from "../Data.Char/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Pitches_Class from "../Data.Pitches.Class/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as StringParser_CodePoints from "../StringParser.CodePoints/index.js";
import * as StringParser_Combinators from "../StringParser.Combinators/index.js";
import * as StringParser_Parser from "../StringParser.Parser/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var bind1 = /* #__PURE__ */ Control_Bind.bind(StringParser_Parser.bindParser);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(StringParser_Parser.applicativeParser);
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_List_Types.foldableNonEmptyList);
var readJSONviaParse = function (dictNotation) {
    var parseNotation = Data_Pitches_Class.parseNotation(dictNotation);
    return function (typ) {
        return function (input) {
            return bind(readImpl(input))(function (str) {
                var v = parseNotation(str);
                if (v instanceof Data_Maybe.Nothing) {
                    return fail(new Foreign.ForeignError("Cannot parse " + (str + (" as " + (typ + "!")))));
                };
                if (v instanceof Data_Maybe.Just) {
                    return pure(v.value0);
                };
                throw new Error("Failed pattern match at Data.Pitches.Internal (line 36, column 3 - line 38, column 21): " + [ v.constructor.name ]);
            });
        };
    };
};
var ascii0 = /* #__PURE__ */ Data_Char.toCharCode("0");
var digit = function (d) {
    return Data_Char.toCharCode(d) - ascii0 | 0;
};
var parseSInt = /* #__PURE__ */ bind1(/* #__PURE__ */ StringParser_Combinators.option("+")(/* #__PURE__ */ StringParser_CodePoints["char"]("-")))(function (signChar) {
    var sign = (function () {
        var $20 = signChar === "-";
        if ($20) {
            return -1 | 0;
        };
        return 1;
    })();
    return bind1(StringParser_Combinators.many1(StringParser_CodePoints.anyDigit))(function (dgts) {
        return pure1(sign * foldl(function (acc) {
            return function (d) {
                return (10 * acc | 0) + digit(d) | 0;
            };
        })(0)(dgts) | 0);
    });
});
var parseUInt = /* #__PURE__ */ bind1(/* #__PURE__ */ StringParser_Combinators.many1(StringParser_CodePoints.anyDigit))(function (dgts) {
    return pure1(foldl(function (acc) {
        return function (d) {
            return (10 * acc | 0) + digit(d) | 0;
        };
    })(0)(dgts));
});
export {
    parseSInt,
    parseUInt,
    readJSONviaParse
};
